import React, { JSX } from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import { ItemApi } from 'appTypes/items'
import { tryParseAsNumber } from 'utils/parser'
import { removeDecimals, round, roundUp } from 'utils/removeDecimals'
import { useTranslation } from 'react-i18next'

type Props = {
  product: ItemApi
}

export const RentalTimeStats = ({ product }: Props): JSX.Element => {
  const { t } = useTranslation('common')

  const getMinimumRentalPrice = () => {
    if (!product || !product.pricing) {
      return null
    }

    let minimalRentalPrice =
      tryParseAsNumber(
        product.pricing.hourly ??
          product.pricing.daily ??
          product.pricing.weekly ??
          product.pricing.monthly ??
          product.pricing.overMonthly,
      ) ?? 0

    const pricingMinimalRentalPrice = tryParseAsNumber(product.pricing.minimalRentalPrice)

    if (pricingMinimalRentalPrice && pricingMinimalRentalPrice > minimalRentalPrice) {
      minimalRentalPrice = pricingMinimalRentalPrice
    }

    let insurancePrice = 0
    if (product.pricing.insurancePercentage) {
      insurancePrice = roundUp((minimalRentalPrice * product.pricing.insurancePercentage) / 100, 0)
      if (product.pricing.insurancePrice && product.pricing.insurancePrice > insurancePrice) {
        insurancePrice = product.pricing.insurancePrice
      }
    } else {
      insurancePrice = product.pricing.insurancePrice ?? 0
    }

    minimalRentalPrice = round(
      minimalRentalPrice + (tryParseAsNumber(product.pricing.handlingPrice) ?? 0) + insurancePrice,
      2,
    )

    const roundedResult = round(minimalRentalPrice, 0)
    return roundedResult
  }

  return (
    <Box width={{ base: '100%', md: '80%' }}>
      {product.averageRentalTime && (
        <Flex alignItems="center" justifyContent="space-between">
          <Text fontSize="sm" fontWeight="semibold" width={{ md: 'calc(100% - 120px)' }}>
            {t('avRentalTime')}{' '}
            <Text as="span" color="updatedLeid.green">
              {product?.averageRentalTime} {t('days')}
            </Text>
          </Text>
        </Flex>
      )}

      {product.pricing?.minimalRentalPrice !== undefined &&
        product.pricing?.minimalRentalPrice !== '' &&
        product.pricing?.minimalRentalPrice !== 0 && (
          <Flex alignItems="center">
            <Text fontSize="sm" fontWeight="semibold" width={{ base: '140px', md: '200px' }}>
              {t('minimumRental')}{' '}
              <Text as="span" color="updatedLeid.green">
                {removeDecimals(getMinimumRentalPrice())} {t('NOK')}
              </Text>
            </Text>
          </Flex>
        )}
    </Box>
  )
}
